<template>
  <div
    class="dropzone"
    :class="{ dragover: dragging, busy }"
    @dragover.prevent="dragging = true"
    @dragleave="dragging = false"
    @drop.prevent="onDrop"
    @click="!busy && input.click()"
    role="button"
    tabindex="0"
    @keydown.enter.prevent="!busy && input.click()"
    @keydown.space.prevent="!busy && input.click()"
  >
    <input ref="input" type="file" multiple accept=".csv,.txt,.zip" style="display:none" @change="onPick" />

    <div v-if="busy" class="dz-busy">
      <span class="spinner"></span>
      <p>{{ busyLabel }}</p>
    </div>
    <template v-else>
      <div class="dz-icon">📂</div>
      <p class="dz-title">Släpp filen här eller klicka för att välja</p>
      <p class="dz-sub">Källan känns igen automatiskt. Flera filer från samma export kan släppas samtidigt.</p>
      <div class="dz-sources">
        <span class="src-chip"><span class="src-icon">🏋️</span> Daily Strength <em>.csv</em></span>
        <span class="src-chip"><span class="src-icon src-g">G</span> Google Takeout <em>.zip</em></span>
      </div>
    </template>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: 'ImportDropZone',
  props: {
    busy: { type: Boolean, default: false },
    // Hel statusrad, t.ex. "Läser sessioner 2 300/7 822…"
    busyLabel: { type: String, default: 'Läser filen…' },
  },
  emits: ['files'],
  setup(props, { emit }) {
    const dragging = ref(false);
    const input = ref(null);
    function onDrop(e) {
      dragging.value = false;
      if (props.busy) return;
      const files = [...(e.dataTransfer?.files || [])];
      if (files.length) emit('files', files);
    }
    function onPick(e) {
      const files = [...(e.target.files || [])];
      if (files.length) emit('files', files);
      e.target.value = '';
    }
    return { dragging, input, onDrop, onPick };
  },
};
</script>

<style scoped>
.dropzone {
  border: 2px dashed var(--gym-border-strong); border-radius: var(--gym-radius-lg);
  padding: 2.25rem 1.25rem; text-align: center; cursor: pointer; background: var(--gym-surface-2);
  transition: border-color var(--gym-dur) var(--gym-ease), background var(--gym-dur) var(--gym-ease), transform var(--gym-dur) var(--gym-ease);
  outline: none;
}
.dropzone:hover, .dropzone:focus-visible, .dragover { border-color: var(--gym-accent); background: var(--gym-accent-softer); }
.dragover { transform: scale(1.01); }
.dropzone.busy { cursor: progress; }

.dz-icon { font-size: 2.6rem; margin-bottom: 0.5rem; }
.dz-title { margin: 0 0 0.3rem; font-weight: 700; color: var(--gym-text); font-size: 1rem; }
.dz-sub { margin: 0 0 1rem; color: var(--gym-text-muted); font-size: 0.85rem; line-height: 1.5; }

.dz-sources { display: flex; gap: 0.5rem; justify-content: center; flex-wrap: wrap; }
.src-chip {
  display: inline-flex; align-items: center; gap: 0.4rem;
  background: var(--gym-surface); border: 1px solid var(--gym-border);
  padding: 0.35rem 0.75rem 0.35rem 0.5rem; border-radius: var(--gym-radius-pill);
  font-size: 0.82rem; font-weight: 600; color: var(--gym-text);
}
.src-chip em { font-style: normal; color: var(--gym-text-faint); font-weight: 500; }
.src-icon { display: inline-grid; place-items: center; width: 22px; height: 22px; border-radius: 50%; background: var(--gym-surface-3); font-size: 0.85rem; }
.src-g { background: #fff; color: #4285f4; font-weight: 800; font-family: Arial, sans-serif; }

.dz-busy { display: flex; flex-direction: column; align-items: center; gap: 0.6rem; color: var(--gym-text-muted); }
.dz-busy p { margin: 0; }
.spinner {
  width: 28px; height: 28px; border-radius: 50%;
  border: 3px solid var(--gym-border-strong); border-top-color: var(--gym-accent);
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }
</style>
